import { render, staticRenderFns } from "./scanCard.vue?vue&type=template&id=6010139d&scoped=true&"
import script from "./scanCard.vue?vue&type=script&lang=js&"
export * from "./scanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6010139d",
  null
  
)

export default component.exports